import React from 'react';
import { useTranslation } from 'react-i18next';
import { routePaths } from '../../../routePaths';
import { WarehousePageWrapper } from '../../../ui-kit';
import { WarehousePermission } from '../../../generated/graphql';
import { WarehousesList } from './warehouses';

const WarehousePage = () => {
    const { t } = useTranslation();

    const addNewWarehouseString = t('Add new warehouse');

    const warehouseActions = [
        {
            route: routePaths.warehouses,
            text: addNewWarehouseString,
        },
    ];

    return (
        <WarehousePageWrapper
            permissions={{ warehouse: [WarehousePermission.CanAddWarehouse] }}
            actions={warehouseActions}
        >
            <WarehousesList />
        </WarehousePageWrapper>
    );
};

export default WarehousePage;
